//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockTextAndMediaImageDisplayItem } from './WebsiteBlockTextAndMediaImageDisplayItem';
import { WebsiteCustomFieldContactFormDisplayItem } from './WebsiteCustomFieldContactFormDisplayItem';
import { WebsiteBlockDisplayItem } from './WebsiteBlockDisplayItem';
import { WebsiteBlockContactFormType, WebsiteBlockType } from './Enums';

export class WebsiteBlockContactFormDisplayItem extends WebsiteBlockDisplayItem {
    Header: string | null = null;
    Body: string | null = null;
    Images: WebsiteBlockTextAndMediaImageDisplayItem[] = [];
    ThankYouMessage: string | null = null;
    ContactFormType: WebsiteBlockContactFormType = WebsiteBlockContactFormType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.ContactForm;
    CustomFields: WebsiteCustomFieldContactFormDisplayItem[] = [];

    constructor(initializer?: Partial<Omit<WebsiteBlockContactFormDisplayItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockContactFormDisplayItem";
}
